import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="calculator" routeLang="en" />;

export const Route = createFileRoute("/en/tools/calculator")({
  head: () => publicToolHead("calculator", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
